import React from 'react';
import { View, ExternalLink, Icon } from '@components';
import { copyToClipboard } from '@utils';

const colorReference = ['#CC4444', '#FF9637', '#66CC66', '#019CE2'];

const getReference = (ms) => {
  if (ms < 1000) {
    return 3;
  } else if (ms < 2500) {
    return 2;
  } else if (ms < 5000) {
    return 1;
  } else {
    return 0;
  }
};

const getColorReference = (ms) => {
  return colorReference[getReference(ms)];
};

const getLinkProcesso = (url) => {
  return url === 'app' ? (
    <View>app</View>
  ) : (
    <View horizontal alignItems='center'>
      <ExternalLink
        style={{ whiteSpace: 'normal' }}
        onClick={(e) => {
          window.location.href = url;
        }}
      >
        {url}
      </ExternalLink>
      &nbsp;
      <Icon.CopyOutlined
        onClick={(e) => {
          copyToClipboard(url);
        }}
      />
    </View>
  );
};

export { getColorReference, getLinkProcesso };
